(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product_upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('.product-upsell-button');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    const variantId = button.dataset.upsellVariant;
    if (!variantId) return;

    button.classList.add('is-loading');
    button.disabled = true;

    try {
      // Step 1: actually add the item to the cart.
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });

      if (!addResponse.ok) {
        const errorData = await addResponse.json().catch(() => ({}));
        throw new Error(errorData.description || 'Could not add item to cart');
      }

      // Step 2: re-render the cart drawer + bubble sections with the
      // now-updated cart, the same way Dawn's own add-to-cart form does.
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {},
          sections: ['cart-drawer', 'cart-icon-bubble']
        })
      });
      const cartData = await updateResponse.json();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(cartData);
        document.querySelector('cart-drawer.drawer')?.classList.remove('is-empty');
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } else {
        // Theme doesn't use Dawn's cart-drawer element — fall back to a
        // generic event other cart UIs may listen for, or a hard refresh.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      }

      button.querySelector('span').textContent = 'Added';
      setTimeout(() => {
        button.querySelector('span').textContent = 'Add +';
      }, 1500);
    } catch (error) {
      console.error('Product upsell add-to-cart error:', error);
      button.querySelector('span').textContent = 'Try again';
      setTimeout(() => {
        button.querySelector('span').textContent = 'Add +';
      }, 1500);
    } finally {
      button.classList.remove('is-loading');
      button.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-estimate-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function getNextShipDate(weekendDays) {
      const date = new Date();
      const day = date.getDay();
      let daysToAdd = 1;

      if (weekendDays.length) {
        const idx = weekendDays.indexOf(day);
        if (idx !== -1) {
          daysToAdd = weekendDays.length - idx + 1;
        }
      }

      date.setDate(date.getDate() + daysToAdd);
      return date;
    }

    function initShippingDate(el) {
      if (el.dataset.shippingInitialized === 'true') return;
      el.dataset.shippingInitialized = 'true';

      const weekendDays = (el.dataset.weekendDays || '')
        .split(',')
        .filter((v) => v !== '')
        .map(Number);

      const shipDate = getNextShipDate(weekendDays);
      const options = { weekday: 'short', month: 'short', day: 'numeric' };
      el.textContent = shipDate.toLocaleDateString('en-US', options);
    }

    // One geolocation lookup shared by every instance of this block on
    // the page, rather than one fetch per block.
    let geoPromise = null;
    function getGeoData() {
      if (!geoPromise) {
        geoPromise = fetch('https://get.geojs.io/v1/ip/geo.json')
          .then((response) => response.json())
          .then((data) => {
            if (!data || !data.country_code) {
              throw new Error('Invalid data from geolocation API');
            }
            return data;
          });
      }
      return geoPromise;
    }

    function initCountryDisplay(flagEl, textEl) {
      if (!flagEl || !textEl) return;
      if (textEl.dataset.countryInitialized === 'true') return;
      textEl.dataset.countryInitialized = 'true';

      getGeoData()
        .then((data) => {
          const countryCode = data.country_code.toUpperCase();
          flagEl.src = `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;
          flagEl.alt = `${countryCode} Flag`;
          flagEl.style.display = 'inline';
          textEl.innerHTML = `Fast <span class="bold">${countryCode}</span> Shipping`;
        })
        .catch((error) => {
          console.error('Error fetching the IP information:', error);
          flagEl.style.display = 'none';
          textEl.textContent = textEl.dataset.fallbackText || 'Fast Worldwide Shipping';
        });
    }

    function initAll() {
      document.querySelectorAll('[data-shipping-date]').forEach(initShippingDate);
      document.querySelectorAll('[data-country-flag]').forEach((flagEl) => {
        const blockId = flagEl.dataset.countryFlag;
        const textEl = document.querySelector(`[data-country-text="${blockId}"]`);
        initCountryDisplay(flagEl, textEl);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swiper_video_items"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-videos')) {
    class ProductVideos extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      init() {
        if (typeof Swiper === 'undefined') {
          this.loadSwiper(() => {
            this.initializeSwiper();
            this.setupVideos();
          });
          return;
        }
        this.initializeSwiper();
        this.setupVideos();
      }

      loadSwiper(callback) {
        if (document.querySelector('script[data-swiper-loaded]')) {
          const check = setInterval(() => {
            if (typeof Swiper !== 'undefined') {
              clearInterval(check);
              callback();
            }
          }, 50);
          return;
        }

        const cssLink = document.createElement('link');
        cssLink.rel = 'stylesheet';
        cssLink.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
        document.head.appendChild(cssLink);

        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.dataset.swiperLoaded = 'true';
        script.onload = callback;
        document.head.appendChild(script);
      }

      setupVideos() {
        this.videos = this.querySelectorAll('.product-videos video');
        this.videos.forEach((video) => {
          video.addEventListener('loadedmetadata', () => {
            video.currentTime = 0.1;
          });

          video.addEventListener('seeked', () => {
            if (!video.hasAttribute('poster')) {
              const canvas = document.createElement('canvas');
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              const ctx = canvas.getContext('2d');
              ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
              video.setAttribute('poster', canvas.toDataURL('image/jpeg'));
            }
          }, { once: true });

          const wrapper = video.closest('.video-wrapper');
          const playPauseBtn = wrapper.querySelector('.video-control-btn');

          video.addEventListener('play', () => {
            this.videos.forEach((otherVideo) => {
              if (otherVideo !== video && !otherVideo.paused) {
                otherVideo.pause();
                otherVideo.closest('.video-wrapper').classList.remove('is-playing');
              }
            });
            wrapper.classList.add('is-playing');
          });

          video.addEventListener('pause', () => {
            wrapper.classList.remove('is-playing');
          });

          wrapper.addEventListener('click', () => {
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          });

          playPauseBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (video.paused) {
              video.play();
            }
          });

          video.setAttribute('preload', 'metadata');
        });
      }

      initializeSwiper() {
        const swiperElement = this.querySelector('.video_item');
        if (!swiperElement) return;

        this.swiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 8,
          grabCursor: true,
          loop: this.querySelectorAll('.swiper-slide').length > 2,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            type: 'progressbar'
          },
          breakpoints: {
            0: { slidesPerView: 2.8 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 3 }
          }
        });
      }
    }

    customElements.define('product-videos', ProductVideos);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["urgency-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function getEndOfDayTimestamp() {
      const endOfDay = new Date();
      endOfDay.setHours(23, 59, 59, 999);
      return endOfDay.getTime();
    }

    function getPersistentEndTimestamp(el) {
      const hours = parseFloat(el.dataset.timerHours) || 24;
      const storageKey = `urgency-timer-end-${el.dataset.timerId}`;
      let endTime = Number(localStorage.getItem(storageKey));

      // If nothing stored yet, or the previously stored countdown has
      // already expired, start a fresh countdown from now.
      if (!endTime || endTime < Date.now()) {
        endTime = Date.now() + hours * 60 * 60 * 1000;
        try {
          localStorage.setItem(storageKey, String(endTime));
        } catch (e) {
          // localStorage unavailable (private browsing etc) — timer
          // still works, it just won't persist across page loads.
        }
      }
      return endTime;
    }

    function formatDuration(ms) {
      let formatted = '00:00:00';
      if (ms > 0) {
        const totalSeconds = Math.floor(ms / 1000);
        const hrs = Math.floor(totalSeconds / 3600);
        const mins = Math.floor((totalSeconds % 3600) / 60);
        const secs = totalSeconds % 60;
        const pad = (num) => String(num).padStart(2, '0');
        formatted = `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
      }
      return formatted;
    }

    function initTimer(el) {
      if (el.dataset.timerInitialized === 'true') return;
      el.dataset.timerInitialized = 'true';

      const template = el.dataset.timerTemplate || 'Ends in [timer]';
      const mode = el.dataset.timerMode;
      const endTimestamp =
        mode === 'persistent'
          ? getPersistentEndTimestamp(el)
          : getEndOfDayTimestamp();

      function update() {
        const diff = endTimestamp - Date.now();
        el.textContent = template.replace('[timer]', formatDuration(diff));
        if (diff <= 0) {
          clearInterval(intervalId);
        }
      }

      update();
      const intervalId = setInterval(update, 1000);
    }

    function initAllTimers() {
      document.querySelectorAll('[data-timer-target]').forEach(initTimer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllTimers);
    } else {
      initAllTimers();
    }

    // Re-run when a merchant edits/re-renders this block in the theme
    // editor, since Shopify swaps the section HTML back in fresh.
    document.addEventListener('shopify:section:load', initAllTimers);
  })();
  } catch(e) { console.error(e); }
})();

})();
